import { render } from "./ItensAvaliacao.vue?vue&type=template&id=11f34201&scoped=true"
import script from "./ItensAvaliacao.vue?vue&type=script&lang=js"
export * from "./ItensAvaliacao.vue?vue&type=script&lang=js"

import "./ItensAvaliacao.vue?vue&type=style&index=0&id=11f34201&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f34201"]])

export default __exports__